import { makeGenericApiAction } from './shared/helpers';

export const fetchEventAction = (eventslug) => async (dispatch) => {
  makeGenericApiAction({
    action: 'FETCH_EVENT',
    model: 'fetchEvent',
    dispatch,
    method: 'get',
    path: `events/getEventBySlug`,
    payload: { eventslug },
  });
};
